import { zip } from 'rxjs/operators';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormArray } from '@angular/forms';
import { Location } from '@angular/common';

import * as _ from 'lodash';

import { ModalComponent } from '../../modal/modal.component';
import { OptmizationMachineSelectorPluginService } from './optimizationmachineselector-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { MachineFamillyService } from '../../shared/services';

@Component({
  selector: 'optimisationmachineselector-edit',
  templateUrl: './optimisationmachineselector-edit.component.html',
  standalone: false
})
export class OptimisationMachineSelectorEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  public plugin: any;
  public machine: any;
  public productLines: any[];
  public categories: any[];

  public modelCurrentItem: any;

  public productCurrentItem: any;
  public productLineSelectorValues: string[] = [];

  public machineModels: any;
  public processing = false;
  @ViewChild('modelsModal', { static: true })
  modal: ModalComponent;
  @ViewChild('productLinesModal', { static: true })
  productLinesModal: ModalComponent;

  machineForm: UntypedFormGroup;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private machineFamillyService: MachineFamillyService,
    private router: Router,
    private service: OptmizationMachineSelectorPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.router.navigate([this.inspectionsRoute]);
      }

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) {
        this.goToBack();
      }

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateMachines(this.inspectionId, this.pluginId, this.getModel(model.data)).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  getModel(data) {
    data.forEach((d) => {
      const selectedItem = _.find(this.machineModels, (o: any) => o.Name === d.name);
      if (selectedItem) {
        d.ModelId = selectedItem.Id;
      }
    });

    return data;
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((el) => {
      this.plugin = el;
      this.machine =
        el.inspection.data != null && el.inspection.data.machine != null ? el.inspection.data.machine : null;
      if (this.machine == null || (this.machine && this.machine.length === 0)) {
        this.initMachine();
      }
      if (this.machine && !(this.machine instanceof Array)) {
        this.machine = [this.machine];
      }

      this.loadData();

      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  loadData() {
    this.machineFamillyService
      .getCurrentScopeProductLines()
      .pipe(zip(this.machineFamillyService.getCategories(), this.service.getModels()))
      .subscribe(([lines, categories, models]) => {
        this.productLines = lines;
        this.categories = categories;
        this.machineModels = models;
        this.productLineSelectorValues = this.productLines.map((p) => p.name);
      });
  }

  public updateModelSelectorValues(id: any, selectedName?: string): {value: string, label: string}[] {
    if (id) {
      let categories = _.filter(this.categories, ['productLineId', id]);
      categories = _.map(categories, 'id');
      const machinesComboData = _.filter(
        this.machineModels,
        (m: any) =>
          (!m.Hidden || m.Name === selectedName) &&
          _.find(categories, (c: any) => {
            return c === m.CategoryId;
          }) !== undefined
      );
      const models: string[] = _.map(machinesComboData, 'Name').sort();
      return models.map((m: any) => ({ label: m, value: m }));
    }
    return [];
  }

  initMachine() {
    this.machine = [
      {
        name: '',
        ProductLine: '',
        CustomerEquipementId: '',
        SerialNumber: '',
        RunningHours: '',
        SheetCount: ''
      }
    ];
  }

  public openModelsSelector(i: number): void {
    const control = <UntypedFormArray>this.machineForm.controls['data'];
    this.modelCurrentItem = control.controls[i];
    const modelsValues = this.updateModelSelectorValues(this.modelCurrentItem.controls['ProductLine'].value, this.modelCurrentItem.controls['name'].value);
    this.openSelector(this.modal, modelsValues, this.modelCurrentItem.controls['name'].value);
  }

  public openProductLinesSelector(i: number): void {
    const control = <UntypedFormArray>this.machineForm.controls['data'];
    this.productCurrentItem = control.controls[i];
    const productIndex = this.productLines.findIndex(
      (pl) => pl.id === this.productCurrentItem.controls['ProductLine'].value
    );
    this.openSelector(this.productLinesModal, this.productLineSelectorValues, productIndex);
  }

  public selectModelsMenu(item: any) {
    // after selector modal close, item.value is {value, label} and item.selectedIndex is the value property of the selected item
    this.modelCurrentItem.controls['name'].setValue(item.selectedIndex);
    this.modelCurrentItem.controls['name'].markAsTouched();
  }

  public selectProductLinesMenu(item: any) {
    // after selector modal close, item.value is string and item.selectedIndex is the index of the selected value
    if (this.productCurrentItem.controls['ProductLine'].value !== this.productLines[item.selectedIndex].id) {
      this.productCurrentItem.controls['name'].setValue('');
    }
    this.productCurrentItem.controls['ProductLine'].setValue(this.productLines[item.selectedIndex].id);
    this.productCurrentItem.controls['ProductLine'].markAsTouched();
  }

  public onProductLinesMenuClose(e: any) {
    this.productCurrentItem.controls['ProductLine'].markAsTouched();
  }

  public onClose() {
    this.modelCurrentItem.controls['name'].markAsTouched();
  }

  initForm() {
    this.machineForm = new UntypedFormGroup({
      data: new UntypedFormArray([])
    });

    const control = <UntypedFormArray>this.machineForm.controls['data'];
    this.machine.forEach((m) => {
      control.push(this.initNames(m));
    });
  }

  get formData() {
    return <UntypedFormArray>this.machineForm.controls['data'];
  }

  initNames(el?) {
    return new UntypedFormGroup({
      name: new UntypedFormControl(el ? el.name : '', Validators.required),
      ProductLine: new UntypedFormControl(el ? el.ProductLine : '', Validators.required),
      CustomerEquipementId: new UntypedFormControl(el ? el.CustomerEquipementId : ''),
      SerialNumber: new UntypedFormControl(el ? el.SerialNumber : ''),
      RunningHours: new UntypedFormControl(el ? el.RunningHours : ''),
      SheetCount: new UntypedFormControl(el ? el.SheetCount : '')
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  add() {
    const control = <UntypedFormArray>this.machineForm.controls['data'];
    control.push(this.initNames());
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.machineForm.controls['data'];
    control.removeAt(i);
  }
}
